import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UtilsService } from '../services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(public auth: AuthService, public utilsService: UtilsService, public router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (route.queryParams['d_doc']) {
      localStorage.setItem('d_doc', route.queryParams['d_doc'].replace('%20').trim());
    }
    if (!this.auth.isAuthenticated()) {
      if (!this.utilsService.inPortal()) {
        localStorage.clear();
        this.auth.loginRedirectAd();
      }
      else {
        this.auth.logout('TEAM');
      }

      return false;
    }
    return true;
  }

}
